module.exports = __webpack_public_path__ + "static/media/Mockup1.ff6293e1.png";